export const DATABASE = 'gridfly.review'
export const STORE = 'intents'
export const SNAPSHOT_STORE = 'snapshots'
export const VERSION = 2

function ensureIntents(db: IDBDatabase, tx: IDBTransaction): void {
  const store = db.objectStoreNames.contains(STORE)
    ? tx.objectStore(STORE)
    : db.createObjectStore(STORE, { keyPath: 'idempotencyKey' })
  // Per sessione e per stato, non scorrendo tutto: a fine turno il deposito
  // contiene centinaia di righe applicate, e cercare fra tutte quelle
  // ancora da consegnare significherebbe scorrerle a ogni battito.
  if (!store.indexNames.contains('sessionId')) store.createIndex('sessionId', 'sessionId')
  if (!store.indexNames.contains('sessionId_state')) {
    store.createIndex('sessionId_state', ['sessionId', 'state'])
  }
  if (!store.indexNames.contains('createdAt')) store.createIndex('createdAt', 'createdAt')
}

function ensureSnapshots(db: IDBDatabase): void {
  if (!db.objectStoreNames.contains(SNAPSHOT_STORE)) {
    db.createObjectStore(SNAPSHOT_STORE, { keyPath: 'key' })
  }
}

function ensureSchema(db: IDBDatabase, tx: IDBTransaction): void {
  ensureIntents(db, tx)
  ensureSnapshots(db)
}

function requireStores(db: IDBDatabase, requiredStores: readonly string[]): void {
  for (const store of requiredStores) {
    if (!db.objectStoreNames.contains(store)) {
      throw new Error(`review schema incomplete: missing store "${store}"`)
    }
  }
}

export function openReviewDatabase(
  requiredStores: readonly string[],
  factory: IDBFactory = indexedDB,
): Promise<IDBDatabase> {
  return new Promise((done, fail) => {
    const request = factory.open(DATABASE, VERSION)
    let settled = false
    const complete = (action: () => void): void => {
      if (settled) return
      settled = true
      action()
    }

    request.onupgradeneeded = () => {
      const tx = request.transaction
      if (tx === null) {
        complete(() => fail(new Error('review schema upgrade failed: missing transaction')))
        return
      }
      ensureSchema(request.result, tx)
    }
    request.onblocked = () => {
      complete(() => fail(new Error('review storage blocked by another tab')))
    }
    request.onerror = () => {
      complete(() => fail(request.error ?? new Error('review storage unavailable')))
    }
    request.onsuccess = () => {
      const db = request.result
      try {
        requireStores(db, requiredStores)
      } catch (error) {
        db.close()
        complete(() => fail(error))
        return
      }
      complete(() => done(db))
    }
  })
}
